import { mdiCircleMedium } from '@mdi/js';
import Icon from '@mdi/react';

import styles from './LoadingDots.module.scss';

const LoadingDots = ({ ...props }) => {
    return (
        <div className={styles.container} data-testid={props['data-testid']}>
            <Icon path={mdiCircleMedium} size={0.5} className={styles.dotOne}/>
            <Icon path={mdiCircleMedium} size={0.5} className={styles.dotTwo}/>
            <Icon path={mdiCircleMedium} size={0.5} className={styles.dotThree}/>
        </div>
    );
};

export default LoadingDots;
